export const checkMatchingArraysValues = (
  a: string[],
  b: string[]
): boolean => {
  return JSON.stringify(a.sort()) === JSON.stringify(b.sort());
};

export const isTokenValid: (token: string) => boolean = (token: string) =>
  token != null && !["undefined", 'null', ''].includes(token)